import { DocumentReference, ISoftDelete } from '@principle-theorem/shared';
import { IPatient } from '../patient/patient';
import { IMarketingCampaign } from './campaign';
import { IMarketingCampaignRun } from './campaign-run';
import { MarketingCampaignStepConversionType } from './campaign-step';

export interface IMarketingCampaignEntryEngagement extends ISoftDelete {
  patientRef: DocumentReference<IPatient>;
  campaignRef: DocumentReference<IMarketingCampaign>;
  campaignRunRef: DocumentReference<IMarketingCampaignRun>;
  conversionType: MarketingCampaignStepConversionType;
  details?: string;
}
